import Vue from 'vue';
import Main from './main.vue';
let ImagePreviewConstructor = Vue.extend(Main);

let instance;

const ImagePreview = function (src, list) {
    if (Vue.prototype.$isServer) return;
    let options = {
        src: src,
        list: list
    }
    options.onClose = function () {
        ImagePreview.close()
    }
    instance = new ImagePreviewConstructor({
        data: options
    });
    instance.vm = instance.$mount();
    document.body.appendChild(instance.vm.$el);
    instance.vm.visible = true;
    instance.dom = instance.vm.$el;
    //   instance.dom.style.zIndex = PopupManager.nextZIndex();
    // instances.push(instance);
    return instance.vm;
};

ImagePreview.show = (src, list) => {
    return ImagePreview(src, list);
};

ImagePreview.close = function () {
    document.body.removeChild(instance.vm.$el)
};
export default ImagePreview;



// WEBPACK FOOTER //
// ./src/components/modal/imagePreview/main.js